
import {
  createContext,
  useCallback,
  useContext,
  useState,
} from "react";

const RouterContext = createContext(null);

export function RouterProvider({ children }) {
  const [route, setRoute] = useState({
    page: "dashboard",
    params: {},
  });

  const [history, setHistory] = useState([]);

  // --------------------------------------------------
  // NAVIGATE
  // --------------------------------------------------

  const navigate = useCallback(
    (page, params = {}, options = {}) => {

      const newRoute = { page, params };

      if (options.replace) {
        // Replace current route without adding history
        setRoute(newRoute);
      } else {
        // Normal navigation: push current route
        setHistory((prev) => [...prev, route]);
        setRoute(newRoute);
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    [route]
  );

  // --------------------------------------------------
  // BACK
  // --------------------------------------------------

  const back = useCallback(() => {
    setHistory((prev) => {
      if (prev.length === 0) return prev;

      const last = prev[prev.length - 1];

      setRoute(last);

      return prev.slice(0, -1);
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <RouterContext.Provider
      value={{
        route,
        navigate,
        back,
      }}
    >
      {children}
    </RouterContext.Provider>
  );
}

export const useRouter = () => useContext(RouterContext);
